import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { LoginService } from 'app/login/services/login.service';

@Component({
  selector: 'app-sign-in-up',
  templateUrl: './sign-in-up.component.html',
  styleUrls: ['./sign-in-up.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class SignInUpComponent implements OnInit {
  isLoading: boolean = false;
  activeTabIndex;
  
  constructor(private loginService: LoginService, private _cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.activeTabIndex = 0;
      this.isLoading = true;
      this._cdr.markForCheck();
    }, 510);
  }
  closeDialog() {
    this.loginService.closeLoginDialog();
  }
}
